import React, { FC } from 'react';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { PhaseStatusProgressDates } from 'components/atoms/progress';
import { Rate } from 'components/atoms/rate';
import { ProgressStatusBar } from 'components/molecules/projects/progress-status';
import { BodyShort01, Caption01, Text02 } from 'components/styles';
import { useProjectDetail } from 'data/projects';
import { EmptyCard } from './_card-empty';

const Wrapper = styled.div`
  margin-bottom: var(--layout-01);
`;
const ProgressName = styled.p`
  margin-bottom: var(--spacing-03);
`;

const PhaseCSAT = styled.p`
  margin-bottom: var(--spacing-03);
  display: flex;
  align-items: center;
`;

const RatingValue = styled.p`
  ${BodyShort01};
`;

const ProgressWrapper = styled.div`
  position: relative;
`;

const ProgressDates = styled(PhaseStatusProgressDates)`
  > span {
    ${Caption01};
    ${Text02};

    &:first-child {
      left: var(--spacing-04);
    }

    &:last-child {
      right: var(--spacing-04);
    }
  }
`;

export const Content: FC<{ projectId: number }> = ({ projectId }) => {
  const { data: project } = useProjectDetail(ProjectId(projectId));

  return (
    <>
      {project ? (
        (project.projectPhases ?? []).length > 0 ? (
          project.projectPhases.map((phase) => {
            const csatValue = phase.aggregateProgressValues?.csatRating ?? 0;

            return (
              <Wrapper key={phase.projectPhaseId}>
                <ProgressName>{phase.projectPhaseName}</ProgressName>

                {csatValue > 0 ? (
                  <PhaseCSAT>
                    <Rate disabled value={csatValue} />
                    <RatingValue className="ant-rate-text">
                      {csatValue}
                    </RatingValue>
                  </PhaseCSAT>
                ) : null}

                <ProgressWrapper>
                  <ProgressStatusBar
                    progressStatuses={phase.progressStatus}
                    strokeWidth={24}
                    subTitle={phase.projectPhaseName}
                  />

                  <ProgressDates
                    startDate={phase.startDate}
                    dueDate={phase.dueDate}
                  />
                </ProgressWrapper>
              </Wrapper>
            );
          })
        ) : (
          <EmptyCard projectId={projectId} />
        )
      ) : null}
    </>
  );
};
